// Styles
import"./AdminInsetBox.css";// Types
import mixins from"vue-typed-mixins";// Main
const AdminInsetBox=mixins().extend({render(){var a,b;const c=arguments[0];return c("div",{class:"admin-inset-box"},[null===(a=(b=this.$scopedSlots).default)||void 0===a?void 0:a.call(b,{})])}});export default AdminInsetBox;